import { getEnv } from "./envManager";
import { readOfficeHostPlatformOrUnknown } from "./office-host";

export const DEFAULT_MAX_BATCH_PAYLOAD_CHARS = 4 * 1024 * 1024;
export const DESKTOP_MAX_BATCH_PAYLOAD_CHARS = 16 * 1024 * 1024;

const DESKTOP_PLATFORMS_MEASURED_AT_THE_LARGER_CAP: ReadonlySet<string> = new Set(["Mac", "PC"]);

export function defaultMaxBatchPayloadCharsOn(hostPlatform: string): number {
    return DESKTOP_PLATFORMS_MEASURED_AT_THE_LARGER_CAP.has(hostPlatform) ? DESKTOP_MAX_BATCH_PAYLOAD_CHARS : DEFAULT_MAX_BATCH_PAYLOAD_CHARS;
}

export function resolveMaxBatchPayloadChars(raw: string | undefined, hostPlatform: string): number {
    const parsed = Number(raw);
    return Number.isInteger(parsed) && parsed > 0 ? parsed : defaultMaxBatchPayloadCharsOn(hostPlatform);
}

export function maxBatchPayloadChars(): number {
    return resolveMaxBatchPayloadChars(getEnv("BULK_APPLY_MAX_BATCH_PAYLOAD_CHARS"), readOfficeHostPlatformOrUnknown());
}

interface PayloadSizedEntry {
    target_ooxml_after: string[];
}

export function entryPayload(entry: PayloadSizedEntry): string {
    return entry.target_ooxml_after[0] ?? "";
}

export function entryPayloadChars(entry: PayloadSizedEntry): number {
    return entryPayload(entry).length;
}

export function packMergeEntriesIntoBatches<T extends PayloadSizedEntry>(
    entries: T[],
    maxPayloadChars: number,
): T[][] {
    const batches: T[][] = [];
    let currentBatch: T[] = [];
    let currentChars = 0;

    for (const entry of entries) {
        const entryChars = entryPayloadChars(entry);
        if (currentBatch.length > 0 && currentChars + entryChars > maxPayloadChars) {
            batches.push(currentBatch);
            currentBatch = [];
            currentChars = 0;
        }
        currentBatch.push(entry);
        currentChars += entryChars;
    }

    if (currentBatch.length > 0) {
        batches.push(currentBatch);
    }

    return batches;
}
